export default function CumulativeScoreAnswer({ parentObject }) {
  return (
    <p>
      <i>
        {parentObject.cumulative_score} out of {parentObject.max_cumulative_score} possible points
      </i>
    </p>
  );
}
